module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators 1-w960.bd602a6e.jpg";